import React from "react";
import styles from "./ErrorProcessingDialog.module.scss";
import Clear from "@mui/icons-material/Clear";
import { styled } from "@mui/material/styles";
import { Dialog } from "@mui/material";
import Grid from "@mui/material/Grid";

const StyledDialog = styled(Dialog)({
  "& .MuiPaper-root": {
    width: 500,
    maxWidth: 500,
    padding: 12,
  },
});

const StyledClear = styled(Clear)({
  width: 27,
  height: 27,
  fill: "#102b4e",
  align: "right",
});

const ErrorProcessingDialog = (props) => {
  return (
    <StyledDialog
      open={props.open}
      className={styles.errorDialog}
      onClose={props.close}
    >
      <Grid container className={styles.errorDialogContainer} justify="center">
        <Grid item md={12} className={styles.errorDialogClose}>
          <div>
            <button onClick={props.close}>
              <StyledClear />
            </button>
          </div>
        </Grid>

        <Grid item md={9}>
          <div className={styles.errorDialogTitle}>
            <span className={styles.errorDialogWarning} />
            <div>{props.title}</div>
          </div>
        </Grid>

        <Grid item md={9}>
          <div className={styles.errorDialogDescription}>{props.body}</div>
        </Grid>
      </Grid>
    </StyledDialog>
  );
};

export default ErrorProcessingDialog;
